import { lineArc } from "../../../turf/geoSpatialAnalysis";
import { GeoJSON } from "ol/format";
import { Projection } from "../../../types";
import { LineString } from "ol/geom";

const DEFAULT_ARC_OPTIONS = {
    steps: 101,
    units: "nauticalmiles",
};

export const circularArcCoordinates = (
    centerPoint: number[],
    radius: number,
    bearing1: number,
    bearing2: number,
    projection: string,
    clockwise: boolean = true,
    options: { steps: number } = DEFAULT_ARC_OPTIONS
) => {
    const arc = circularArc(centerPoint, radius, bearing1, bearing2, clockwise, options);
    const arcFeature = new GeoJSON().readFeatures(arc, {
        featureProjection: projection,
        dataProjection: Projection.EPSG_4326,
    });

    return (arcFeature[0].getGeometry()!.clone() as LineString).getCoordinates();
};

export const circularArc = (
    centerPoint: number[],
    radius: number,
    bearing1: number,
    bearing2: number,
    clockwise: boolean = true,
    options: { steps: number } = DEFAULT_ARC_OPTIONS
) => {
    return clockwise
        ? lineArc(centerPoint, radius, bearing1, bearing2, options)
        : lineArc(centerPoint, radius, bearing2, bearing1, options);
};
